__webpack_require__.p = "https://app.minerva26.com/packs/";